module.exports = __webpack_public_path__ + "static/assets/9676adc91fb7cf0144630a68fafe0b14.svg";